<template>
  <div>
    <form data-vv-scope="flow-part-1">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Datos para el flujo</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nombre para el flujo (*)"
            maxlength="120"
            name="name"
            v-model="step.name"
            :danger="errors.has('flow-part-1.name')"
            :danger-text="errors.first('flow-part-1.name')"
            v-validate="'required'"
          />
        </div>
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Descripción para el flujo (*)"
            name="description"
            v-model="step.description"
            :danger="errors.has('flow-part-1.description')"
            :danger-text="errors.first('flow-part-1.description')"
            v-validate="'required'"
            maxlength="550"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6" v-if="!step.oldFlow">
          <div class="row">
            <div class="col-md-8 d-flex align-items-end">
              <label>Estampar aprobaciones</label>
              <InfoApprovalStamp/>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="pdfStamp"
                :vs-value="true"
                v-model="step.pdfStamp"
                data-cy="pdfStampYes"
              >
                Si
              </vs-radio>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="pdfStamp"
                :vs-value="false"
                v-model="step.pdfStamp"
                data-cy="pdfStampNo"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div >
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-8 d-flex align-items-end">
              <label>Flujo privado</label>
              <InfoPrivateFlow />
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="private"
                :vs-value="true"
                v-model="step.private"
                data-cy="privateYes"
              >
                Si
              </vs-radio>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="private"
                :vs-value="false"
                v-model="step.private"
                data-cy="privateNo"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-8 d-flex align-items-end">
              <label>¿Quieres basarte en un flujo actual?</label>
              <InfoOldApproval/>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="oldFlow"
                :vs-value="true"
                v-model="step.oldFlow"
                data-cy="oldFlowYes"
              >
                Si
              </vs-radio>
            </div>
            <div class="col-md-2">
              <vs-radio
                vs-name="oldFlow"
                :vs-value="false"
                v-model="step.oldFlow"
                data-cy="oldFlowNo"
              >
                No
              </vs-radio>
            </div>
          </div>

        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6" v-if="step.oldFlow">
          <div
            class="row"
            data-cy="plantilla-tipo"
          >
            <div class="col-md-12 d-flex align-items-end">
              <label>¿Que plantillas quieres ver?</label>
              <div class="text-right">
                <b-button
                  size="sm"
                  class="btn-icon rounded-circle mt-1"
                  id="popover-attended"
                  variant="flat-primary"
                >
                  <feather-icon icon="InfoIcon"/>
                </b-button>
                <b-popover
                  target="popover-attended"
                  triggers="focus"
                  placement="top"
                >
                  <template #title>
                    <span>Tipo de plantilla!</span>
                  </template>
                  <span>
                 <strong>Atendidas:</strong>
                Flujos con interacción humana en donde cada participante debe realizar sus acciones
              </span>
                  <br>
                  <span>
                 <strong>
                   Desatendidas:
                 </strong>
                Flujos sin interacción humana que se procesan automáticamente
              </span>
                </b-popover>
              </div>
            </div>
          </div>

          <div
            class="row"
            data-cy="plantilla-tipo-opciones"
          >
            <div class="col-md-6">
              <vs-radio
                vs-name="attendedOnly"
                :vs-value="0"
                v-model="attendedOnly"
                data-cy="attendedOnly-0"
              >
                Atendidas
              </vs-radio>
            </div>
            <div class="col-md-6">
              <vs-radio
                vs-name="attendedOnly"
                :disabled="disableDesattendedOnly"
                :vs-value="1"
                v-model="attendedOnly"
                data-cy="attendedOnly-1"
              >
                Desatendidas
              </vs-radio>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-3" v-if="step.oldFlow">
          <label for="flow-select">
            Selecciona el flujo
          </label>
          <v-select
            v-model="step.flowId"
            :options="filteredApprovalsTemplates"
            name="flow-select"
            id="flow-select"
            label="nombre"
            data-cy="select-template"
            placeholder="Selecciona el flujo"
            :reduce="option => option.id"
          >
            <template v-slot:option="{id,nombre}">
              <span
                :data-cy-value="id"
                :data-cy-label="nombre"
              >
                {{ nombre }}
              </span>
            </template>
            <template slot="no-options">
              no hay flujos
            </template>
          </v-select>
        </div>
        <div class="col-md-6 mt-3" v-if="!step.oldFlow">
          <BooleanParameter
            v-if="!isMasive"
            :is-approval-sign="true"
            :disabled="disableSignaturePosition"
            param-id="aprobaciones.firmas.ubicacion"
            v-model="step.setSignaturePosition"
            @input="onSetSignaturePositionChange"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="hasOfficeOldFlow">
        <div class="col-md-6 mt-3">
          <list-document-types
            :type-numeration="numerationFlowType === 'I' ? 'numInt' : 'numOf'"
            class="w-100"
            autocomplete
            label="Tipo Documento (*)"
            name="documentTypeOffice"
            v-model="step.documentTypeOffice"
            :danger="errors.has('flow-part-1.documentTypeOffice')"
            :danger-text="errors.first('flow-part-1.documentTypeOffice')"
            v-validate="'required'"
            data-vv-as="tipo documento"
            ref="documentTypes"
          />
        </div>
        <div class="col-md-6 mt-3">
          <list-documents
            :type-numeration="numerationFlowType === 'I' ? 'numInt' : 'numOf'"
            class="w-100"
            autocomplete
            label="Documento (*)"
            name="documentOffice"
            v-model="step.documentOffice"
            :parent-value="step.documentTypeOffice"
            ref="documents"
            data-vv-as="documento"
            :danger="errors.has('flow-part-1.documentOffice')"
            :danger-text="errors.first('flow-part-1.documentOffice')"
            v-validate="{'required': hasOfficeOldFlow}"
            @input-option="onDocumentTypeChangeNumeration"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="!hasOfficeOldFlow">
        <div class="col-md-6 mt-3">
          <list-all-document-types
            data-vv-as="tipo documento"
            usage="aprobaciones"
            class="w-100"
            autocomplete
            label="Tipo Documento"
            name="documentType"
            v-model="step.documentType"
            ref="documentTypes"
            @input-option="onDocumentTypeChange"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div
          class="col-md-6 mt-3"
          v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')"
        >
          <b-form-group
            label="Empresa (*)"
          >
            <v-select
              class="w-100 b-radius"
              v-model="step.author"
              :options="authorAguasAndinas"
              :clearable="false"
              data-cy="author"
              name="author"
              data-vv-as="autor"
              v-validate="{required: isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')}"
              :class="{
                'v-select-danger': errors.has('flow-part-1.author'),
                'select-size-sm': errors.has('flow-part-1.author')
              }"
            />
            <div
              v-if="errors.has('flow-part-1.author')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;"
            >
              <span class="span-text-validation">
                {{ errors.first('flow-part-1.author') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div
          class="col-md-6 col-xs-12 col-sm-12 mt-3"
          v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')"
        >
          <list-institution-types
            class="w-100"
            autocomplete
            label="Tipo Institución (*)"
            name="institutionType"
            v-model="step.institutionType"
            :danger="errors.has('flow-part-1.institutionType')"
            :danger-text="errors.first('flow-part-1.institutionType')"
            v-validate="{required: isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')}"
            ref="institutionType"
          />
        </div>
      </div>
      <div class="row mb-3 mt-3">
        <div class="col-md-12" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
          <label for="matter">Materia (*)</label>
          <vs-textarea
            type="text"
            id="matter"
            label="Materia (Mínimo 3 caracteres, máximo 5000 caracteres)"
            data-cy="matter"
            name="matter"
            width="100%"
            v-validate="{
              required: isAguasAndinas && step.documentType
              && step.documentType.toLowerCase().includes('carta'),
              min: 3
            }"
            height="100px"
            maxlength="5000"
            class="mb-0"
            v-model="step.matter"
          />
          <div class="row">
            <div class="col-md-6 text-left">
              <div v-if="errors.first('flow-part-1.matter')"
                   class="con-text-validation span-text-validation-danger
             vs-input--text-validation-span v-enter-to"
                   style="height: 32px;">
            <span class="span-text-validation">
              {{errors.first('flow-part-1.matter')}}
            </span>
              </div>
            </div>
            <div class="col-md-6 text-right" v-if="step.matter">
              <span v-tooltip="'Contador de caracteres'">{{step.matter.length}}/5000</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
          <label>Fecha Documento</label>
          <b-form-datepicker
            today-button
            reset-button
            close-button
            v-bind="configBFormDate.labels[locale] || {}"
            :max="maxDate"
            :locale="locale"
            :show-decade-nav="false"
            :hide-header="false"
            v-model="step.issueDate"
            name="issueDate"
            data-vv-as="fecha documento"
            data-cy="issue-date"
          />
          <div
            v-if="errors.has('flow-part-1.issueDate')"
            class="con-text-validation span-text-validation-danger v-enter-to"
            style="height: 19px;"
          >
          <span class="span-text-validation">
            {{ errors.first('flow-part-1.issueDate') }}
          </span>
          </div>
        </div>
        <!--<div class="col-md-6 mt-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
          <vs-input
            class="w-100"
            label="Número Doc. Madre"
            maxlength="120"
            name="name"
            v-model="step.motherDocument"
          />
        </div>-->
        <div class="col-md-6 mt-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
          <vs-input
            autocomplete="off"
            class="w-100"
            data-cy="mother-document-number"
            label="Nº Documento Madre"
            v-model="step.motherDocument"
            data-vv-as="documento madre"
            name="documentNumberMother"
            v-on:keyup="searchForMother()"
          />
          <ul id="list"
              v-if="(motherDocumentsList.length > 0 || loadingMotherDocuments) && showListSelect">
            <li v-if="loadingMotherDocuments">
              <span class="muted-light">Buscando...</span>
            </li>
            <li v-for="item in motherDocumentsList"
                @click="setDocumentMother(item)"
                v-bind:key="item.numero"
            >
              <span>{{ item.numero }}</span>
              <span class="muted-light">
                creado el {{ formatDate(item.fechaCreacion) }}
              </span>
              <span class="muted-light">
                nº interno {{item.numeroInt}}
              </span>
              <p>Creado por <b>{{ item.solicitanteNombre}}</b> ({{ item.solicitanteEmail}})</p>
            </li>
          </ul>
          <small class="text-danger" v-if="error.message">{{error.message}}</small>
        </div>
        <div class="col-md-6 mt-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
          <b-form-group
            label="Tema (*)"
          >
            <v-select
              class="w-100 b-radius"
              v-model="step.theme"
              :options="themesAguasAndinas"
              :clearable="false"
              :reduce="option => option.id"
              data-cy="theme"
              name="theme"
              data-vv-as="tema"
              v-validate="{required: isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')}"
              :class="{
                'v-select-danger': errors.has('flow-part-1.theme'),
                'select-size-sm': errors.has('flow-part-1.theme')
              }"
            />
            <div
              v-if="errors.has('flow-part-1.theme')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('flow-part-1.theme') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 mt-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
          <b-form-group
            label="Sub-tema (*)"
          >
            <v-select
              class="w-100 b-radius"
              v-model="step.subTheme"
              :options="subThemesAguasAndinas"
              :reduce="option => option.id"
              :clearable="false"
              data-cy="sub-theme"
              name="subtheme"
              data-vv-as="sub-tema"
              v-validate="{required: isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')}"
              :class="{
                'v-select-danger': errors.has('flow-part-1.subtheme'),
                'select-size-sm': errors.has('flow-part-1.subtheme')
              }"
            />
            <div
              v-if="errors.has('flow-part-1.subtheme')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('flow-part-1.subtheme') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row mb-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
      <div class="row mb-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
        <div class="col-md-12">
          <h4>Documentos Relacionados</h4>
        </div>
        <div class="col-md-12 mb-3">
          <add-related-document @add-related-document="addRelatedDocument" />
        </div>
        <div class="col-md-12">
          <table-related-documents
            :related-documents="step.relatedDocuments"
            v-model="step.relatedDocumentsSelected"
            multiple
          />
        </div>
      </div>
      <div class="row mb-3" v-if="isAguasAndinas && step.documentType
           && step.documentType.toLowerCase().includes('carta')">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
      <div class="row mb-3 mt-4">
        <div class="col-md-3 d-flex align-items-end">
          <UploadFile
            permission="*"
            text="Cargar Archivos Adjuntos"
            accept="application/pdf"
            v-model="additionalFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
            @input="addAdditionalFile()"
          />
        </div>
        <div class="col-3" v-for="file in step.attachments" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="45px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeAdditionalFile(file.id)"
            />
          </div>
        </div>
      </div>
    </form>
    <form data-vv-scope="flow-part-2">
      <div class="row mb-3 mt-3">
        <div class="col-12">
          <h4>Detalle del flujo</h4>
        </div>
      </div>
      <StepsOldFlow v-if="step.oldFlow && oldFlow.pasos" :steps="oldFlow.pasos" />
      <div class="row mb-5" v-if="!step.oldFlow">
        <div class="col-3">
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de paso (*)"
            name="stepType"
            v-model="stepType"
            :danger="errors.has('flow-part-2.stepType')"
            :danger-text="errors.first('flow-part-2.stepType')"
            v-validate="'required'"
          >
            <vs-select-item
              :value="stepTypes.USER"
              text="Usuario"
            />
            <vs-select-item
              :value="stepTypes.GROUP"
              text="Grupo"
            />
            <vs-select-item
              v-if="isGore && officeStepDoc.includes(wizardData.documentType)"
              :value="stepTypes.OFFICE"
              text="Oficina"
            />
          </vs-select>
        </div>
        <div
          class="col-6"
          v-if="stepType === this.stepTypes.OFFICE"
        >
          <list-offices
            class="w-100 mb-1"
            autocomplete
            label="Oficina del responsable"
            name="groupStep"
            v-model="groupStep"
            data-vv-as="oficina"
            :typeList="99"
            withFilters
            :officeType="typeNumeration"
            :filterMyOffices="filterUserOffices"
            ref="groupStep"
            :danger="errors.has('flow-part-2.groupStep')"
            :danger-text="errors.first('flow-part-2.groupStep')"
            v-validate="{ required: stepType === this.stepTypes.OFFICE }"
          />
          <small class="text-danger">
            Si le falta una oficina, favor notificar al equipo de Soporte
            para que verifiquen que esté correctamente configurada
          </small>
        </div>
        <div
          class="col-6"
          v-if="stepType === stepTypes.GROUP"
        >
          <list-groups
            class="w-100"
            autocomplete
            label="Grupo del responsable (*)"
            name="groupStep"
            v-model="groupStep"
            :typeList="stepType"
            :officeType="wizardData.fileCategory"
            ref="groupStep"
            :danger="errors.has('flow-part-2.groupStep')"
            :danger-text="errors.first('flow-part-2.groupStep')"
            v-validate="{ required: stepType === stepTypes.GROUP }"
          />
        </div>
        <div
          class="col-6"
          v-if="stepType === stepTypes.USER"
        >
          <list-user
            class="w-100"
            autocomplete
            label="Usuario (*)"
            name="userStep"
            isApprovals
            v-model="userStep"
            ref="userStep"
            :danger="errors.has('flow-part-2.userStep')"
            :danger-text="errors.first('flow-part-2.userStep')"
            v-validate="{ required: stepType === stepTypes.USER }"
          />
        </div>
        <div class="col-3" v-if="stepType !== stepTypes.OFFICE">
          <b-form-group
            label="Tipo de rol (*)"
          >
            <v-select
              id="rolType"
              label="label"
              :options="rolTypesOption"
              :reduce="rol => rol.id"
              name="rolType"
              v-model="rolType"
              :class="{ danger: errors.has('flow-part-2.rolType') }"
              v-validate="'required'"
            />
           <InfoRolType/>
            <span
              v-show="errors.has('flow-part-2.rolType')"
              class="danger span-text-validation-danger v-enter-to"
            >
              {{ errors.first('flow-part-2.rolType') }}
            </span>
          </b-form-group>
        </div>
        <div class="col-3" v-if="stepType === stepTypes.OFFICE">
          <b-form-group
            label="Tipo de rol"
          >
            <v-select
              label="label"
              :options="rolTypesOfficeOption"
              :reduce="rol => rol.id"
              name="rolType"
              v-model="rolType"
              :class="{ danger: errors.has('flow-part-2.rolType') }"
              v-validate="'required'"
            />
            <div class="text-right">
              info
              <b-button
                size="sm"
                class="btn-icon rounded-circle mt-1"
                id="popover-button-default"
                variant="flat-primary"
              >
                <feather-icon icon="InfoIcon" />
              </b-button>
              <b-popover
                target="popover-button-default"
                triggers="focus"
                placement="top"
              >
                <template #title>
                  <span>Tipos de roles!</span>
                </template>
                <span>
                  <b>+ Numerar/tramitar:</b> Permite firmar documentos, esto cuenta como la
                  aprobación, se coloca un estampado de numeración o trámite.
                </span>
              </b-popover>
            </div>
            <span
              v-show="errors.has('flow-part-2.rolType')"
              class="danger span-text-validation-danger v-enter-to"
            >
              {{ errors.first('flow-part-2.rolType') }}
            </span>
          </b-form-group>
        </div>
      </div>
      <div class="row mb-3" v-if="!step.oldFlow">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button
            color="primary"
            icon="add"
            :disabled="blockButton"
            v-on:click="addStep()"
            data-cy="add-step"
          >
            Agregar Paso
          </vs-button>
        </div>
      </div>
      <div class="row mb-3" v-if="step.steps.length">
        <div
          class="col-3"
          v-for="(step, index) in step.steps" :key="`step-${index}`"
        >
          <div class="step-wrapper">
            <span class="step-number">{{step.stepNumber}}</span>
            <span class="step-delete">
              <vs-icon
                icon="highlight_off"
                size="small"
                bg="white"
                round
                @click="removeStep(step)"
              />
            </span>
            <div class="text-center step-name">
              {{ step.responsibleName }}
              <span
                v-if="step.stepType === stepTypes.GROUP || step.stepType === stepTypes.OFFICE"
              >
                {{(step.groupUsers.length) }}
              </span>
            </div>
            <div class="step-type">
              <span v-if="step.stepType === stepTypes.USER">
                usuario
              </span>
              <span v-if="step.stepType === stepTypes.GROUP">
                grupo
              </span>
              <span v-if="step.stepType === stepTypes.OFFICE">
                oficina
              </span>
            </div>
            <div class="step-rol">
              <span v-if="step.rolType === rolTypes.APPROVER">
                aprobador
              </span>
              <span
                class="bg-success badges"
                v-if="step.rolType === rolTypes.SIGNER
                   && step.stepType !== stepTypes.OFFICE"
              >
                  Firmante
                </span>
              <span
                class="bg-success badges"
                v-if="step.rolType === rolTypes.SIGNER
                   && step.stepType === stepTypes.OFFICE"
              >
                  Numerar/tramitar
                </span>
              <span v-if="step.rolType === rolTypes.REVIEWER">
                revisor
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
      </div>
      <div v-if="(isGore || isInh) && showSubjectsButton">
        <h6 style="font-size: 12px;" class="my-2 text-primary">
          destinos
        </h6>
        <b-button
          v-b-modal="'modal-subjects'"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-info"
          class="btn-icon rounded-circle shadow-lg"
          data-cy="btn-destinations"
        >
          <feather-icon icon="UsersIcon" />
        </b-button>
        <Subjects />
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import ListDocumentTypes from "@/febos/chile/lists/components/ListDocumentTypes";
import ListDocuments from "@/febos/chile/lists/components/ListDocuments";
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListUser from '@/febos/chile/lists/components/ListUser';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import BooleanParameter from '@/febos/chile/tools/components/BooleanParameter';
import StepsOldFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsOldFlow';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import ListAllDocumentTypes from '@/febos/chile/lists/components/ListAllDocumentTypes';
import { getUsersByGroup } from '@/febos/servicios/api/empresas.api';
import { getDocumentDetail } from '@/febos/servicios/api/customDocuments.api';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import authors from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Authors';
import InfoApprovalStamp from '@/febos/chile/approvals/wizardFlow/components/InfoApprovalStamp';
import InfoOldApproval from '@/febos/chile/approvals/wizardFlow/components/InfoOldApproval';
import InfoRolType from '@/febos/chile/approvals/wizardFlow/components/InfoRolType';
import InfoPrivateFlow from '@/febos/chile/approvals/wizardFlow/components/InfoPrivateFlow';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import Subjects from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Subjects';
import ListInstitutionTypes from '@/febos/chile/lists/components/ListInstitutionTypes';
import Themes from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Themes';
import configBFormDate from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/ConfigBFormDate';
import AddRelatedDocument from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/AddRelatedDocument';
import TableRelatedDocuments from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/TableRelatedDocuments';
import { ioExpedientesSearch } from '@/febos/servicios/api/busqueda.api';
import { getApprovalTemplate } from '@/febos/servicios/api/aprobaciones.api';
import SelectOptions from "@/febos/global/customDocuments/components/SelectOptions.vue";
import {getSheetsConfig} from "@/febos/servicios/api/dnt.api";
import {INH} from "@/constants/companies";
import {FEBOS_SA} from "../../../../../../../tests/e2e/specs/ED/constant/empresas";

export default {
  mixins: [WizardStep],
  components: {
    SelectOptions,
    ListDocuments,
    ListDocumentTypes,
    ListInstitutionTypes,
    AddRelatedDocument,
    TableRelatedDocuments,
    InfoRolType,
    InfoOldApproval,
    InfoApprovalStamp,
    Subjects,
    ListOffices,
    ListGroups,
    ListUser,
    BooleanParameter,
    StepsOldFlow,
    UploadFile,
    ListAllDocumentTypes,
    InfoPrivateFlow
  },
  data() {
    const { query } = this.$route;
    return {
      attendedOnly: 0,
      query,
      officeStepDoc: ['RES', 'OF', 'MEMO', 'RESUGDPS', 'RESINH'],
      officialNumeration: ['OF', 'RES', 'RESUGDPS', 'RESINH'],
      subjectsDocument: ['OF', 'RES', 'RESUGDPS', 'MEMO', 'RESINH'],
      rolTypesOfficeOption: [
        { id: RolTypes.SIGNER, label: 'Numerar/Tramitar' }
      ],
      authorAguasAndinas: authors,
      step: {
        documentTypeId: null,
        documentTypeOffice: '',
        documentOffice: '',
        author: '',
        fileId: this.$route.params.id,
        oldFlow: !this.isAguasAndinas,
        documentType: '',
        setSignaturePosition: false,
        mainFile: {
          name: '',
          path: ''
        },
        matter: '',
        relatedDocumentsSelected: [],
        relatedDocuments: [],
        ...this.draft
      },
      temas: Themes,
      themesAguasAndinas: [],
      configBFormDate,
      locale: 'es',
      additionalFile: {},
      showListSelect: false,
      loadingMotherDocuments: false,
      motherDocumentsFullList: [],
      disableSignaturePosition: false,
      disableDesattendedOnly: false
    };
  },
  watch: {
    wizardData(newValue) {
      this.step.name = newValue.fileName;
      this.step.mainFile.path = newValue.filePath;
      this.step.mainFile.name = newValue.fileName;
      if (this.step.name.toLowerCase().includes('.docx')) {
        this.disableDesattendedOnly = true;
      }
      this.removeSignaturesDropped();
    },
    attendedOnly() {
      this.step.flowId = undefined;
    },
    // eslint-disable-next-line func-names
    'step.documentType': function (val) {
      if (!val) {
        this.step.documentType = '';
      } else {
        this.step.documentType = val;
      }
    },
    'step.oldFlow': function watchOldFlow(newValue) {
      if (!newValue) {
        this.step.flowId = undefined;
        if (this.step.mainFile && this.step.mainFile.name && this.step.mainFile.name.toLowerCase().endsWith('.docx')) {
          this.step.setSignaturePosition = false;
          this.disableSignaturePosition = true;
          this.onSetSignaturePositionChange(false);
        } else {
          this.disableSignaturePosition = false;
          this.onSetSignaturePositionChange(false);
        }
      }
    },
    'step.setSignaturePosition': function watchSinatureField() {
      if (!this.step.oldFlow && this.step.mainFile.name.toLowerCase().endsWith('.docx')) {
        this.step.setSignaturePosition = false;
        this.disableSignaturePosition = true;
        this.onSetSignaturePositionChange(false);
      }
    }
  },
  computed: {
    ...mapGetters('List', [
      'documentsState'
    ]),
    ...mapGetters('List', [
      'groupUsersState',
      'userGroupsState'
    ]),
    ...mapGetters('Empresas', ['companyId', 'company']),
    ...mapGetters('Approvals', [
      'wizardData',
      'approvalsTemplates'
    ]),
    numerationFlowType() {
      const { aprobacion } = this.oldFlow;
      return aprobacion.tipoOficina || '';
    },
    hasOfficeOldFlow() {
      const { pasos = [] } = this.oldFlow;
      return pasos
        .some((step) => (step.aprobacionesTipoPasoId === this.stepTypes.OFFICE.toString()));
    },
    officeOldFlow() {
      const { pasos = [] } = this.oldFlow;
      return pasos
        .find((step) => (step.aprobacionesTipoPasoId === this.stepTypes.OFFICE.toString()));
    },
    isMasive() {
      return this.draft.files || this.draft.folderId;
    },
    filteredApprovalsTemplates() {
      return this.approvalsTemplates.filter((item) => item.desatendida === this.attendedOnly);
    },
    showSubjectsButton() {
      return this.subjectsDocument.includes(this.wizardData.documentType);
    },
    isGore() {
      return this.company.iut === '72235100-2';
    },
    isInh() {
      return this.company.iut === INH.iut;
    },
    motherDocumentsList() {
      const result = this.motherDocumentsFullList.filter(
        (x) => {
          try {
            return x.numeroInt.includes(this.step.motherDocument);
          } catch (e) {
            return false;
          }
        }
      ).slice(0, 5);
      if (typeof result === 'undefined') return [];
      return result;
    },
    subThemesAguasAndinas() {
      const result = this.temas.find((el) => el.tema.id === this.step.theme);
      if (this.step.theme === '') {
        return [];
      }
      return result && result.subtema;
    },
    maxDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return new Date(today);
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    isLetter() {
      if (this.step.documentType) {
        const document = this.$refs.documentTypes ? this.$refs.documentTypes.getOption() : {};
        if (document && document.label) {
          return document.label.toLowerCase().includes('carta');
        }
      }
      return false;
    },
    typeNumeration() {
      if (this.officialNumeration.includes(this.wizardData.documentType)) {
        return 'numOf';
      }
      return 'numInt';
    },
    filterUserOffices() {
      return this.typeNumeration === 'numInt' && this.isGore;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    ...mapActions('Approvals', [
      'getApprovalsTemplates',
      'removeSignaturesDropped'
    ]),
    async addRelatedDocument(row) {
      const isSelected = this.step.relatedDocumentsSelected
        .some((relatedDoc) => relatedDoc.id === row.id
          && relatedDoc.type === row.type && relatedDoc.number === row.number);

      if (!isSelected) {
        this.step.relatedDocuments.push(row);
        this.step.relatedDocumentsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta referencia',
          {
            title: '¡HEEEY!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.step.attachments.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.step.attachments = this.step.attachments.filter((file) => file.id !== fileId);
    },
    async addStep() {
      this.blockButton = true;
      this.error.message = '';
      const isValid = await this.validateForm('flow-part-2');

      if (!isValid) {
        this.blockButton = false;
        return;
      }

      const responsibleStep = (
        this.stepType === StepTypes.GROUP || this.stepType === StepTypes.OFFICE
      )
        ? this.$refs.groupStep.getOption()
        : this.$refs.userStep.getOption();

      const step = {
        stepType: this.stepType,
        rolType: this.rolType,
        stepNumber: this.step.steps.length + 1,
        responsibleName: responsibleStep.label,
        responsibleId: responsibleStep.id,
        responsibleEmail: responsibleStep.email || '',
        ...((this.stepType === StepTypes.OFFICE && this.isGore) && { disregarded: true })
      };

      if (this.stepType === StepTypes.GROUP) {
        const { data: { usuarios: users } } = await getUsersByGroup({
          empresaId: this.company.id,
          pagina: 1,
          filas: 9999,
          groupId: responsibleStep.id
        });

        step.groupUsers = users.map((user) => ({
          ...user,
          tipoValorResponsableId: user.id
        }));
      }

      this.step.steps.push(step);

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.blockButton = false;
      await this.$validator.reset();
    },
    onDocumentTypeChange(option) {
      if (option) {
        this.step.documentTypeId = option?.id;
      } else {
        this.step.matter = '';
        this.step.theme = '';
        this.step.subTheme = '';
        this.step.motherDocument = '';
        this.step.relatedDocuments = [];
        this.step.issueDate = '';
        this.step.institutionType = '';
      }
    },

    onDocumentTypeChangeNumeration(option) {
      const { extra = {} } = option;
      this.step.isNumeration = extra.uso && extra.uso.numeracion;
      this.step.isManagement = extra.uso && extra.uso.tramite;

      if (option) {
        this.step.documentTypeId = option?.id;
      }
    },

    transformTemplateSteps(templateSteps) {
      return templateSteps.map((step) => ({
        ...step,
        rolType: parseInt(step.aprobacionesTipoRolId, 10)
      }));
    },
    async validateTemplateSteps() {
      try {
        const [response] = await Promise.all([
          getApprovalTemplate({ id: this.step.flowId })
        ]);
        const templateSteps = response.data?.aprobacion?.pasos || [];
        const transformedSteps = this.transformTemplateSteps(templateSteps);

        if (!this.hasReviewer(transformedSteps)) {
          this.error.message = 'Para transformar a PDF debe tener un revisor';
          return false;
        }
        if (!this.checkReviewerBeforeSigner(transformedSteps)) {
          this.error.message = 'Debe haber al menos un revisor antes del primer firmante en el flujo';
          return false;
        }
        if (!this.checkReviewerBeforeSigner(transformedSteps)) {
          this.error.message = 'Debe haber al menos un firmante antes del paso de oficina en el flujo';
          return false;
        }
        return true;
      } catch (error) {
        console.error('Error al ejecutar', error);
        this.error.message = 'Error al obtener la plantilla';
        return false;
      }
    },

    hasReviewer(steps) {
      return steps.some((step) => step.rolType === this.rolTypes.REVIEWER);
    },

    checkReviewerBeforeSigner(steps) {
      const signerIndex = steps.findIndex((step) => step.rolType === this.rolTypes.SIGNER);
      if (signerIndex === -1) {
        return true;
      }
      const hasReviewerBeforeSigner = steps.slice(0, signerIndex)
        .some((step) => step.rolType === this.rolTypes.REVIEWER);
      return hasReviewerBeforeSigner;
    },
    async isValid() {
      const isDocxFile = this.step.mainFile.name.toLowerCase().endsWith('.docx');
      if (isDocxFile && this.validIfStepsHasSigner()) {
        if (this.step.steps.length === 0 && this.step.flowId) {
          const isTemplateValid = await this.validateTemplateSteps();
          if (!isTemplateValid) {
            return false;
          }
        } else {
          if (!this.hasReviewer(this.step.steps)) {
            this.error.message = 'Para transformar a PDF debe tener un revisor';
            return false;
          }
          if (!this.checkReviewerBeforeSigner(this.step.steps)) {
            this.error.message = 'Debe haber al menos un revisor antes del primer firmante en el flujo';
            return false;
          }
        }
      }
      this.error.message = '';
      const flowValidation = await Promise.all([
        this.validateForm('flow-part-1')
      ]);

      if (
        this.step.setSignaturePosition
        && !this.step.steps.some((step) => (step.rolType === RolTypes.SIGNER))
      ) {
        this.error.message = 'Debes agregar al menos un paso que pueda firmar';
        throw new Error(this.error.message);
      }

      if (flowValidation.some((step) => !step)) {
        return false;
      }

      const officeId = this.step.oldFlow && (this.oldFlow.pasos
        .find((step) => step.aprobacionesTipoPasoId === this.stepTypes.OFFICE
          || step.aprobacionesTipoPasoId === this.stepTypes.OFFICE.toString()) || {}).tipoValorResponsableId;

      if (officeId) {
        if (!this.step.documentOffice) {
          this.error.message = 'No es posible encontrar configuración '
            + 'de numeración para este documento';
          return false;
        }

        this.searchingConfig = true;
        const document = this.documentsState.list.find((doc) => doc.value === this.step.documentOffice);
        console.log('doc', document)
        const { data: { configFolios = [] } } = await getSheetsConfig({
          tipoDocId: document.id,
          alcanceId: officeId
        });

        this.searchingConfig = false;
        if (!configFolios.length) {
          this.error.message = 'No existe configuración de numeración para este documento';
        }
        return configFolios.length;
      }

      this.checkIfFlowHasSteps();
      this.checkIfLastStepsIsRevisor();
      return true;
    },
    getStepData() {
      const institutionTypeName = this.step.institutionType
        ? {
          institutionTypeName: this.$refs.institutionType.getOption()?.value
        }
        : {};
      let metaOffice = [];
      if (this.step.isNumeration) {
        metaOffice = ['foliar'];
      }
      if (this.step.isManagement) {
        metaOffice = ['tramitar'];
      }
      if (this.step.isManagement && this.step.isNumeration) {
        metaOffice = ['foliar', 'tramitar'];
      }
      const metadataStep = this.hasOfficeOldFlow ? { oficinaAcciones: metaOffice } : {};
      return {
        fileNumber: this.wizardData.fileNumber,
        fileUrl: this.wizardData.fileUrl,
        fileName: 'Archivo-Repositorio',
        typeFlowId: 'ARCHIVO-RP',
        typeFlowText: 'ARCHIVO-RP',
        fileType: 'ARCHIVO-RP',
        // TODO: mover al mapper. @lettunia
        privado: 'N',
        metadataStep: metadataStep,
        ...institutionTypeName,
        ...this.step
      };
    },
    onSetSignaturePositionChange(newValue) {
      this.$emit('update-steps');
      this.$emit('loaded');

      if (!newValue) {
        this.step.signaturesDropped = {};
        this.removeSignaturesDropped();
      }
    },
    async searchForMother() {
      this.showListSelect = true;
      this.loadingMotherDocuments = true;
      const payload = {
        params: {
          elementosPorPagina: 5,
          pagina: 1,
          filtros: `numeroInt:${this.step.motherDocument}|emisorRut:${this.company.iut}|estado:!!!3|estadoCodigoEstadoComprador:1`,
          orden: '-fechaCreacion'
        }
      };
      try {
        const res = await ioExpedientesSearch(payload);
        const that = this;
        res.data.documentos.forEach((element) => that.motherDocumentsFullList.push(element));
        const keys = ['numeroInt', 'fechaCreacion'];
        this.motherDocumentsFullList = this.motherDocumentsFullList.filter(
          // this basically delete duplicates, using added keys before
          ((s) => (o) => ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|')))(new Set())
        );
        if (!this.motherDocumentsFullList.length) {
          this.setDocumentMother({
            numero: this.step.documentNumberMother,
            febosId: '',
            codigo: 'mother',
            linea: '1',
            tipoDocumento: 'EXP'
          });
        }
      } catch (e) {
        // nothing to do
      }
      this.loadingMotherDocuments = false;
    },
    formatDate(fullDate) {
      const date = fullDate.split(' ')[0];
      const year = date.split('-')[0];
      const month = date.split('-')[1];
      const day = date.split('-')[2];
      const months = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      return `${day} de ${months[parseInt(month, 10)]}, ${year}`;
    },
    setDocumentMother(item) {
      this.step.motherDocument = item.numero;
      this.showListSelect = false;
      this.error.message = '';
    }
  },
  async created() {
    await this.getApprovalsTemplates({
      params: {
        filtros: `iutEmpresa:${this.company.id}|aprobacionesEstado:Y|filtrarUnidad:Y|tipoObjeto:ARCHIVO`,
        pagina: 1,
        orden: '-fechaCreacion',
        itemsPorPagina: 2000,
      }
    });
    await this.fetchUserGroups();
    this.step.mainFile.path = this.step.filePath;
    this.step.mainFile.name = this.step.fileName;
    const { id, codeType } = this.$route.params;
    this.step.oldFlow = !this.isAguasAndinas;
    if (codeType) {
      const response = await getDocumentDetail({
        codeType,
        id,
        json: 'si',
        pdf: 'no'
      });
      const { referencia, materia, documentType } = response.data.document;
      switch (documentType) {
        case 'SV':
          this.step.name = `Solicitudes varias - ${referencia}`;
          break;
        case 'ADP':
          this.step.name = `Ampliación de plazo - ${referencia}`;
          break;
        default:
          console.log('default');
          break;
      }
      this.step.description = materia;
    } else {
      this.step.name = this.wizardData.fileName;
    }
    if (this.query && this.query.codeType && this.isAguasAndinas) {
      this.step.documentType = 'CARTA';
    }
    this.themesAguasAndinas = this.temas.map((el) => el.tema);
  }
};
</script>
<style>

.step-wrapper {
  border: 1px solid #662483;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  margin-top: 20px;
}

.step-number {
  position: absolute;
  top: -10px;
  left: -4px;
  padding: 2px 8px;
  background: #16c86b;
  border-radius: 50%;
  color: white;
  font-size: 12px;
}

.step-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: #b11e0b;
  cursor: pointer;
}

.step-rol {
  position: absolute;
  bottom: -10px;
  right: -1px;
  padding: 2px 8px;
  background: #671e85;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-type {
  position: absolute;
  bottom: -10px;
  left: -1px;
  padding: 2px 8px;
  background: #155f87;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-name {
  padding: 8px 0;
}
#list {
  font-size: 12px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  background-color: white;
  border-radius: 0 0 5px 5px;
  border: 1px #ccc solid;
  position: absolute;
  z-index:100;

}

#list li {
  display: block;
  padding: 5px 15px;
}

#list li:hover {
  background-color: #ccc;
  /*   color: white; */
}

#list li span {
  font-weight: 550;
}

#list li p {
  margin: 5px 0 0;
}
.muted-light{
  color:#aaa;
  font-weight:100;
}
</style>
